import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import ApiKeysPanel from './ApiKeysPanel';
import WebhooksPanel from './WebhooksPanel';
import RetentionPanel from './RetentionPanel';
import XeroPanel from './XeroPanel';
import { useAddon } from '../addons/useAddon';

const TAB_KEYS = ['api-keys', 'webhooks', 'retention', 'xero'];

/** Integrations (INTEGRATION_MANAGE): read-only API keys, outbound webhooks, document retention and (add-on) Xero. */
const Integrations: React.FC = () => {
    const xeroOn = useAddon('xero');
    const [params] = useSearchParams();
    const asked = TAB_KEYS.indexOf(params.get('tab') ?? '');
    const [tab, setTab] = useState(asked >= 0 ? asked : 0);
    // A ?tab=xero link (bell notice, callback page) falls back to the first tab while the add-on is off.
    const shown = tab === 3 && !xeroOn ? 0 : tab;
    return (
        <Box sx={{ p: { xs: 1, sm: 3 } }} data-help-page="data.integrations.page">
            <Typography variant="h5" gutterBottom>Integrations</Typography>
            <Tabs value={shown} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" sx={{ mb: 2 }}>
                <Tab label="API keys" data-testid="tab-api-keys" data-help="data.integrations.tab.apiKeys" />
                <Tab label="Webhooks" data-testid="tab-webhooks" data-help="data.integrations.tab.webhooks" />
                <Tab label="Retention" data-testid="tab-retention" data-help="data.integrations.tab.retention" />
                {xeroOn && <Tab label="Xero" value={3} data-testid="tab-xero" data-help="data.integrations.tab.xero" />}
            </Tabs>
            {shown === 0 && <ApiKeysPanel />}
            {shown === 1 && <WebhooksPanel />}
            {shown === 2 && <RetentionPanel />}
            {shown === 3 && <XeroPanel />}
        </Box>
    );
};

export default Integrations;
